export const nav = {
  home: 'Home',
  about: 'About Us',
  services: 'Services',
  gallery: 'Gallery',
  contact: 'Contact',
  book: 'Book Appointment',
  logout: 'Logout',
  admin: 'Bookings',
};

export const hero = {
  headline: "N's Group Ltd. — Reliable Container Vanning Solutions for Global Vehicle Export",
  subheadline: 'Professional container loading services for cars, trucks and machinery exports.',
  requestQuote: 'Request a Quote',
  contactUs: 'Contact Us',
};

export const about = {
  label: "ABOUT N'S GROUP",
  headline1: 'Trusted Partner in',
  headline2: 'Vehicle Export',
  headline3: 'Logistics',
  paragraph1: "N's Group Ltd. is a leading provider of professional container vanning services for vehicle exports. With years of experience in the logistics industry, we specialize in safe and efficient loading of cars, trucks, heavy machinery, and automotive parts into shipping containers.",
  paragraph2: 'Our team of experienced professionals ensures every vehicle is properly secured and protected during the loading process. We work closely with exporters, trading companies, and freight forwarders to deliver reliable container loading operations that meet international shipping standards.',
  learnMore: 'Learn More',
};

export const services = {
  label: 'OUR SERVICES',
  headline1: 'Complete Container',
  headline2: 'Vanning Solutions',
  subtitle: 'Professional loading services tailored for global vehicle export',
  service1: {
    title: 'Container Vanning',
    items: [
      'Professional vehicle loading',
      'Safe container packing',
      'Quality inspection',
      'Loading documentation',
    ],
  },
  service2: {
    title: 'Vehicle Export Logistics',
    items: [
      'Export coordination',
      'Customs documentation',
      'Shipping arrangement',
      'Logistics support',
    ],
  },
  service3: {
    title: 'Heavy Equipment Loading',
    items: [
      'Machinery loading',
      'Truck loading services',
      'Equipment securing',
      'Special handling',
    ],
  },
  service4: {
    title: 'Space Optimization',
    items: [
      'Container space planning',
      'Maximum load efficiency',
      'Cost optimization',
      'Load calculation',
    ],
  },
  service5: {
    title: 'Cargo Securing',
    items: [
      'Professional securing methods',
      'Damage prevention',
      'Safety compliance',
      'Protection materials',
    ],
  },
  service6: {
    title: 'Export Documentation',
    items: [
      'Loading reports',
      'Photo documentation',
      'Certificate issuance',
      'Compliance records',
    ],
  },
};

export const industries = {
  label: 'INDUSTRIES WE SUPPORT',
  headline1: 'Serving Global',
  headline2: 'Export Markets',
  industry1: {
    title: 'Used Car Exporters',
    description: 'Professional container loading services for used vehicle export businesses worldwide.',
  },
  industry2: {
    title: 'Automotive Trading',
    description: 'Supporting international automotive trading companies with reliable vanning operations.',
  },
  industry3: {
    title: 'Machinery Exporters',
    description: 'Specialized loading services for heavy equipment and construction machinery exports.',
  },
  industry4: {
    title: 'Freight Forwarders',
    description: 'Partnering with freight forwarding companies for seamless container loading services.',
  },
};

export const whyChoose = {
  label: 'WHY CHOOSE US',
  headline1: 'Experience',
  headline2: 'Meets',
  headline3: 'Excellence',
  paragraph: "With years of expertise in vehicle export logistics, N's Group Ltd. delivers professional container vanning services that ensure your cargo arrives safely and efficiently at its destination.",
  viewProcess: 'View Our Process',
  feature1: {
    title: 'Experienced Professionals',
    description: 'Our skilled team has extensive experience in container loading operations and vehicle export logistics.',
  },
  feature2: {
    title: 'Safe Cargo Handling',
    description: 'We prioritize safety with proper securing methods and damage prevention techniques for every shipment.',
  },
  feature3: {
    title: 'Efficient Operations',
    description: 'Streamlined processes and optimized workflows ensure fast turnaround times for your exports.',
  },
  feature4: {
    title: 'Fast Turnaround',
    description: 'Quick and reliable service delivery to meet your tight shipping schedules and deadlines.',
  },
};

export const process = {
  label: 'HOW IT WORKS',
  headline: 'Simple Five-Step Process',
  step1: {
    title: 'Inquiry & Quote',
    description: 'Contact us with your vehicle export requirements and receive a detailed quote for our container vanning services.',
  },
  step2: {
    title: 'Booking Confirmation',
    description: 'Confirm your booking and schedule the container loading date that works best for your export timeline.',
  },
  step3: {
    title: 'Vehicle Arrival',
    description: 'Deliver your vehicles to our facility where our team will inspect and prepare them for container loading.',
  },
  step4: {
    title: 'Container Loading',
    description: 'Our experienced professionals carefully load and secure your vehicles in the container using proper techniques.',
  },
  step5: {
    title: 'Export Ready',
    description: 'Receive loading documentation and photos. Your container is now ready for shipment to its destination.',
  },
};

export const testimonials = {
  label: 'CLIENT REVIEWS',
  headline1: 'Trusted by Exporters',
  headline2: 'Worldwide',
  subtitle: 'See what our clients say about our container vanning services',
  review1: {
    headline: 'Professional and Reliable Service',
    text: "N's Group has been our trusted partner for container loading for over 3 years. Their team is professional, efficient, and always delivers on time. Highly recommended for vehicle export logistics.",
    name: 'Michael Chen',
    company: 'Global Auto Trading Co.',
  },
  review2: {
    headline: 'Excellent Container Loading',
    text: "The quality of their container vanning service is outstanding. Every vehicle arrives at destination in perfect condition. Their attention to detail and cargo securing methods are top-notch.",
    name: 'Sarah Johnson',
    company: 'International Motors Ltd.',
  },
  review3: {
    headline: 'Fast and Efficient Operations',
    text: "We export hundreds of vehicles monthly and N's Group handles our container loading with impressive speed and efficiency. Their team is experienced and very professional.",
    name: 'Takeshi Yamamoto',
    company: 'Pacific Export Solutions',
  },
  review4: {
    headline: 'Great Communication',
    text: 'Communication is excellent throughout the entire process. They provide detailed loading reports and photos, which gives us confidence in their service quality.',
    name: 'David Martinez',
    company: 'Euro-Asia Logistics',
  },
  review5: {
    headline: 'Cost-Effective Solutions',
    text: 'Their space optimization expertise helps us maximize container capacity and reduce shipping costs. Great value for professional container vanning services.',
    name: 'Lisa Anderson',
    company: 'Worldwide Vehicle Exports',
  },
  review6: {
    headline: 'Trusted Long-Term Partner',
    text: "We have worked with N's Group for many years and they consistently deliver excellent service. Their reliability and professionalism make them our preferred container loading partner.",
    name: 'Hiroshi Tanaka',
    company: 'Tokyo Auto Export Inc.',
  },
};

export const gallery = {
  label: 'GALLERY',
  headline: 'Our Work in Action',
  viewFull: 'View Full Gallery',
};

export const cta = {
  headline: 'ready to export?',
  description1: 'Get professional container vanning services',
  description2: 'Contact us for a custom quote today',
  button: 'Request Quote Now',
};

export const contact = {
  label: 'GET IN TOUCH',
  headline: 'Request Your Quote',
  form: {
    name: 'Name',
    company: 'Company',
    email: 'Email',
    phone: 'Phone',
    message: 'Message',
    submit: 'Send Inquiry',
    namePlaceholder: 'Your full name',
    companyPlaceholder: 'Your company name',
    emailPlaceholder: 'your@email.com',
    phonePlaceholder: '+81 90-3138-4477',
    messagePlaceholder: 'Tell us about your container vanning requirements...',
  },
  info: {
    location: 'HEAD OFFICE',
    address1: 'Daiya Palace Okachimachi 3 – 505',
    address2: '3-5-10 Higashiueno, Taito-ku',
    address3: 'Tokyo 110-0016, Japan',
    yard: 'YARD / OPERATION BASE',
    yardAddress1: '2964-1 Fuseki, Sakai-machi',
    yardAddress2: 'Sashima District',
    yardAddress3: 'Ibaraki 306-0416, Japan',
    contact: 'PHONE & EMAIL',
    phone: '+81-90-3138-4477',
    email: 'info@nsgroupltd.com',
    hours: 'BUSINESS HOURS',
    hoursText: 'Monday - Friday: 9:00 AM - 6:00 PM',
    hoursText2: 'Saturday: 9:00 AM - 1:00 PM',
  },
};

export const footer = {
  brand: "N'S GROUP LTD.",
  description: 'Professional container vanning solutions for global vehicle export. We provide reliable container loading services for cars, trucks, heavy machinery, and automotive parts to exporters worldwide.',
  quickLinks: 'QUICK LINKS',
  contactInfo: 'CONTACT INFO',
  addressLabel: 'HEAD OFFICE',
  yardLabel: 'YARD / OPERATION BASE',
  phoneLabel: 'PHONE',
  emailLabel: 'EMAIL',
  copyright: "© 2025 N's Group Ltd. All rights reserved.",
  privacy: 'Privacy Policy',
  terms: 'Terms of Service',
  sitemap: 'Sitemap',
};

export const book = {
  badge: "N's Group Ltd. — Online Booking",
  hero_title: 'Book Appointment',
  hero_subtitle: 'We offer 3 types of booking services: Shipping, Loading, and Forwarding.\nPlease select the service you need.',
  section_label: 'Our Services',
  section_title: 'Select a Service',
  section_subtitle: 'Please review the details of each service and proceed to the booking form of your choice.',
  btn_form: 'Go to Form',
  info_yard: 'Yard / Operation Base',
  info_yard_address: '2964-1 Fuseki, Sakai-machi, Sashima District, Ibaraki 306-0416',
  info_hours: 'Business Hours',
  info_hours_text: 'Mon–Fri: 9:00 AM – 6:00 PM\nSat: 9:00 AM – 1:00 PM',
  info_phone: 'Phone Booking',
  services: {
    shipping: {
      label: 'SHIPPING APPOINTMENT',
      title: 'Shipping Appointment',
      subtitle: 'Shipping Appointment',
      description: 'Easily book container vanning online. Please enter the type of cargo, number of units, and preferred schedule.',
      features: ['Passenger cars, trucks, heavy machinery', 'Container size selection', 'CY cutoff date management', 'Preferred time slot'],
    },
    loading: {
      label: 'LOADING APPOINTMENT',
      title: 'Loading Appointment',
      subtitle: 'Loading Appointment',
      description: 'Easily book container loading operations online. Please specify the loading method, location, and schedule.',
      features: ['Forklift & crane support', 'Container number management', 'Loading location selection', 'RoRo & manual loading'],
    },
    forwarding: {
      label: 'FORWARDING APPOINTMENT',
      title: 'Forwarding Appointment',
      subtitle: 'Forwarding Appointment',
      description: 'Book international shipping and customs clearance consultations online. We provide full support from transport routes to documentation.',
      features: ['Sea & air freight', 'Customs clearance support', 'Incoterms support', 'Worldwide shipping'],
    },
  },
};

export const appointment = {
  badge: 'SHIPPING APPOINTMENT',
  hero_title: 'Shipping Booking Form',
  hero_subtitle: 'Easily book container vanning online.\nPlease fill in the required fields and submit.',
  sec1_title: 'Customer Information',
  sec2_title: 'Cargo Details',
  sec3_title: 'Preferred Schedule',
  sec4_title: 'Notes & Other',
  field_name: 'Full Name',
  field_company: 'Company Name',
  field_email: 'Email Address',
  field_phone: 'Phone Number',
  field_cargo_type: 'Cargo Type',
  field_quantity: 'Units / Quantity',
  field_container_size: 'Container Size',
  field_destination: 'Destination (Export)',
  field_preferred_date: 'Preferred Loading Date',
  field_alt_date: '2nd Choice Date',
  field_preferred_time: 'Preferred Time Slot',
  field_cy_cutoff: 'CY Cutoff Date',
  field_notes: 'Requests / Special Notes',
  placeholder_name: 'John Smith',
  placeholder_company: 'Your Company Ltd.',
  placeholder_quantity: 'e.g. 3',
  placeholder_destination: 'e.g. Dubai, UAE',
  placeholder_notes: 'Please describe any special handling requirements or questions...',
  opt_select: 'Please select',
  opt_unspecified: 'Unspecified / Consult',
  opt_no_pref: 'No preference',
  opt_morning: 'Morning (9:00–12:00)',
  opt_afternoon: 'Afternoon (13:00–17:00)',
  cargo_passenger: 'Passenger Car',
  cargo_truck: 'Truck / Commercial Vehicle',
  cargo_heavy: 'Heavy Machinery',
  cargo_motorcycle: 'Motorcycle',
  cargo_parts: 'Auto Parts',
  cargo_other: 'Other',
  container_20: '20ft Container',
  container_40: '40ft Container',
  container_40hc: '40ft HC Container',
  container_45: '45ft Container',
  submit: 'Submit Booking',
  submitting: 'Submitting...',
  new_booking: 'New Booking',
  success_title: 'Booking Received',
  success_msg: 'We will review your booking and contact you shortly.\nUsually within 1–2 business days.',
  required_note: '* Required fields. We will contact you after confirming your booking (1–2 business days).',
  info_yard: 'Yard / Operation Base',
  info_hours: 'Business Hours',
  info_phone: 'Phone Booking',
};

export const loading = {
  badge: 'LOADING APPOINTMENT',
  hero_title: 'Loading Booking Form',
  hero_subtitle: 'Easily book container loading operations online.\nPlease fill in the required fields and submit.',
  sec1_title: 'Customer Information',
  sec2_title: 'Loading Details',
  sec3_title: 'Preferred Schedule',
  sec4_title: 'Notes & Other',
  field_name: 'Full Name',
  field_company: 'Company Name',
  field_email: 'Email Address',
  field_phone: 'Phone Number',
  field_cargo_type: 'Cargo Item',
  field_quantity: 'Units / Quantity',
  field_container_size: 'Container Size',
  field_container_number: 'Container No.',
  field_destination: 'Destination (Export)',
  field_loading_method: 'Loading Method',
  field_preferred_date: 'Preferred Loading Date',
  field_alt_date: '2nd Choice Date',
  field_preferred_time: 'Preferred Time Slot',
  field_cy_cutoff: 'CY Cutoff Date',
  field_etd: 'ETD',
  field_loading_location: 'Loading Location',
  field_notes: 'Requests / Special Notes',
  placeholder_name: 'John Smith',
  placeholder_company: 'Your Company Ltd.',
  placeholder_quantity: 'e.g. 3',
  placeholder_container_number: 'e.g. ABCU1234567',
  placeholder_destination: 'e.g. Dubai, UAE',
  placeholder_notes: 'Please describe any special handling requirements or questions...',
  opt_select: 'Please select',
  opt_unspecified: 'Unspecified / Consult',
  opt_no_pref: 'No preference',
  opt_morning: 'Morning (9:00–12:00)',
  opt_afternoon: 'Afternoon (13:00–17:00)',
  cargo_passenger: 'Passenger Car',
  cargo_truck: 'Truck / Commercial Vehicle',
  cargo_heavy: 'Heavy Machinery',
  cargo_motorcycle: 'Motorcycle',
  cargo_parts: 'Auto Parts',
  cargo_general: 'General Cargo',
  cargo_other: 'Other',
  container_20: '20ft Container',
  container_40: '40ft Container',
  container_40hc: '40ft HC Container',
  container_45: '45ft Container',
  method_roro: 'RoRo (Self-propelled)',
  method_forklift: 'Forklift',
  method_crane: 'Crane',
  method_manual: 'Manual',
  location_yard: 'Our Yard (Sakai-machi)',
  location_port: 'Port Facility',
  location_customer: 'Customer-specified Location',
  submit: 'Submit Booking',
  submitting: 'Submitting...',
  new_booking: 'New Booking',
  success_title: 'Booking Received',
  success_msg: 'We will review your booking and contact you shortly.\nUsually within 1–2 business days.',
  required_note: '* Required fields. We will contact you after confirming your booking (1–2 business days).',
  info_yard: 'Yard / Operation Base',
  info_hours: 'Business Hours',
  info_phone: 'Phone Booking',
};

export const forwarding = {
  badge: 'FORWARDING APPOINTMENT',
  hero_title: 'Forwarding Booking Form',
  hero_subtitle: 'Easily book international shipping and customs clearance consultations online.\nPlease fill in the required fields and submit.',
  sec1_title: 'Customer Information',
  sec2_title: 'Shipping & Cargo Information',
  sec3_title: 'Customs & Documents',
  sec4_title: 'Notes & Other',
  field_name: 'Full Name',
  field_company: 'Company Name',
  field_email: 'Email Address',
  field_phone: 'Phone Number',
  field_service_type: 'Service Type',
  field_cargo_type: 'Cargo Type',
  field_quantity: 'Units / Quantity',
  field_weight: 'Approx. Weight (kg)',
  field_pol: 'Port of Loading',
  field_pod: 'Port of Discharge',
  field_customs: 'Customs Handling',
  field_incoterms: 'Incoterms',
  field_preferred_date: 'Preferred Shipment Date',
  field_preferred_arrival: 'Preferred Arrival Date (est.)',
  field_docs: 'Required Documents (multiple)',
  field_notes: 'Requests / Special Notes',
  placeholder_name: 'John Smith',
  placeholder_company: 'Your Company Ltd.',
  placeholder_quantity: 'e.g. 3',
  placeholder_weight: 'e.g. 5000',
  placeholder_pol: 'e.g. Tokyo Port, Yokohama Port',
  placeholder_pod: 'e.g. Dubai Port, UAE',
  placeholder_notes: 'Please describe special handling, hazardous goods details, or any questions...',
  opt_select: 'Please select',
  opt_unspecified: 'Unspecified / Consult',
  opt_consult: 'Consult',
  service_sea_fcl: 'Sea Freight (FCL)',
  service_sea_lcl: 'Sea Freight (LCL)',
  service_air: 'Air Freight',
  service_multi: 'Multimodal',
  service_customs: 'Customs Only',
  service_consult: 'Consultation / Quote',
  cargo_passenger: 'Passenger Car',
  cargo_truck: 'Truck / Commercial Vehicle',
  cargo_heavy: 'Heavy Machinery',
  cargo_motorcycle: 'Motorcycle',
  cargo_parts: 'Auto Parts',
  cargo_general: 'General Cargo',
  cargo_hazardous: 'Hazardous / Special Cargo',
  cargo_other: 'Other',
  customs_export: 'Export Customs Only',
  customs_import: 'Import Customs Only',
  customs_both: 'Both Export & Import',
  customs_none: 'Not Required',
  customs_consult: 'Consult',
  doc_bl: 'Bill of Lading (B/L)',
  doc_invoice: 'Invoice',
  doc_packing: 'Packing List',
  doc_origin: 'Certificate of Origin',
  doc_insurance: 'Cargo Insurance',
  doc_export_decl: 'Export Declaration',
  submit: 'Submit Booking',
  submitting: 'Submitting...',
  new_booking: 'New Booking',
  success_title: 'Booking Received',
  success_msg: 'We will review your booking and contact you shortly.\nUsually within 1–2 business days.',
  required_note: '* Required fields. We will contact you after confirming your booking (1–2 business days).',
  info_routes: 'Available Routes',
  info_routes_text: 'Middle East, Africa, Southeast Asia\nEurope, North America and more',
  info_hours: 'Business Hours',
  info_phone: 'Phone Consultation',
};

export const login = {
  title: 'Login',
  subtitle: "N's Group Ltd. Admin Panel",
  email: 'Email Address',
  emailPlaceholder: 'admin@nsgroupltd.com',
  password: 'Password',
  passwordPlaceholder: 'Enter your password',
  submit: 'Log In',
  loggingIn: 'Logging in...',
  error: 'Invalid email or password',
  info: 'If you have trouble accessing, please contact the administrator',
  portal: 'Member Portal',
  tab_login: 'Login',
  tab_register: 'Register',
  tab_admin: 'Admin',
  forgot_password: 'Forgot your password?',
  no_account: "Don't have an account?",
  have_account: 'Already have an account?',
  back_to_login: 'Back to Login',
  admin_title: 'Admin Login',
  admin_subtitle: 'Please log in with your admin account',
  admin_submit: 'Login as Admin',
  admin_error: 'Admin authentication failed',
  reg_name: 'Full Name',
  reg_name_placeholder: 'John Smith',
  reg_company: 'Company Name',
  reg_company_placeholder: 'Your Company Ltd.',
  reg_phone: 'Phone Number',
  reg_phone_placeholder: '+81 90-0000-0000',
  reg_email: 'Email Address',
  reg_password: 'Password',
  reg_password_hint: 'At least 6 characters',
  reg_password_placeholder: 'At least 6 characters',
  reg_password_confirm: 'Confirm Password',
  reg_password_confirm_placeholder: 'Enter password again',
  reg_submit: 'Create Account',
  reg_submitting: 'Registering...',
  reg_success_title: 'Registration Complete!',
  reg_success_msg: 'Your account has been created.\nPlease log in to continue.',
  reg_to_login: 'Go to Login',
  reg_error_name: 'Please enter your name',
  reg_error_short: 'Password must be at least 6 characters',
  reg_error_mismatch: 'Passwords do not match',
  reg_error_exists: 'This email address is already registered',
  forgot_title: 'Forgot your password?',
  forgot_subtitle: 'Enter your registered email address.\nWe will help you reset your password.',
  forgot_submit: 'Next',
  forgot_checking: 'Checking...',
  forgot_error: 'This email address is not registered',
  reset_title: 'Set New Password',
  reset_new_password: 'New Password',
  reset_new_password_confirm: 'Confirm New Password',
  reset_submit: 'Update Password',
  reset_updating: 'Updating...',
  reset_success_title: 'Password Updated!',
  reset_success_msg: 'Please log in with your new password.',
  reset_to_login: 'Go to Login',
  copyright: "© 2025 N's Group Ltd. All rights reserved.",
};

export const admin = {
  dashboard_label: 'Admin Dashboard',
  title: 'Booking & Inquiry Management',
  tab_shipping: 'Shipping Bookings',
  tab_loading: 'Loading Bookings',
  tab_forwarding: 'Forwarding Bookings',
  tab_contact: 'Inquiries',
  back_to_site: 'Back to Site',
  logout: 'Logout',
  viewing: 'Viewing',
  count_unit: 'entries',
  refresh: 'Refresh',
  loading: 'Loading data...',
  fetch_error: 'Failed to fetch data. Please try again.',
  retry: 'Retry',
  footer_note: 'This page is for administrators only. Data is retrieved from the Readdy form service.',
  table: {
    detail_title: 'Details',
    received_at: 'Received At',
    reply_email: 'Reply by Email',
    search_placeholder: 'Search by name, company, or email...',
    no_data: 'No data available',
    filter_all: 'All',
    filter_unread: 'Unread',
    filter_read: 'Read',
    mark_all_read: 'Mark all as read',
    unread_count: '{{count}} unread',
    status_read: 'Read',
    status_unread: 'Unread',
    fields: {
      shipping: {
        name: 'Name',
        company: 'Company',
        email: 'Email',
        phone: 'Phone',
        cargo_type: 'Cargo Type',
        quantity: 'Quantity',
        container_size: 'Container Size',
        destination: 'Destination',
        preferred_date: 'Preferred Date',
        alternative_date: '2nd Choice Date',
        preferred_time: 'Preferred Time',
        cy_cutoff: 'CY Cutoff',
        notes: 'Notes',
      },
      loading: {
        name: 'Name',
        company: 'Company',
        email: 'Email',
        phone: 'Phone',
        cargo_type: 'Cargo Item',
        quantity: 'Quantity',
        container_size: 'Container Size',
        container_number: 'Container No.',
        destination: 'Destination',
        loading_method: 'Loading Method',
        preferred_date: 'Preferred Date',
        alternative_date: '2nd Choice Date',
        preferred_time: 'Preferred Time',
        cy_cutoff: 'CY Cutoff',
        etd: 'ETD',
        loading_location: 'Loading Location',
        notes: 'Notes',
      },
      forwarding: {
        name: 'Name',
        company: 'Company',
        email: 'Email',
        phone: 'Phone',
        service_type: 'Service Type',
        cargo_type: 'Cargo Type',
        quantity: 'Quantity',
        weight: 'Weight',
        port_of_loading: 'Port of Loading',
        port_of_discharge: 'Port of Discharge',
        customs_handling: 'Customs Handling',
        incoterms: 'Incoterms',
        preferred_date: 'Preferred Shipment Date',
        preferred_arrival: 'Preferred Arrival',
        notes: 'Notes',
      },
      contact: {
        name: 'Name',
        company: 'Company',
        email: 'Email',
        phone: 'Phone',
        message: 'Message',
      },
    },
  },
};

// About Page
export const aboutPage = {
  hero: {
    title: 'About N\'s Group Ltd',
    subtitle: 'Based in Hong Kong, we provide trusted container vanning services to customers worldwide.',
  },
  mission: {
    title: 'Our Mission',
    description: 'N\'s Group Ltd is committed to handling your cargo safely and efficiently. With extensive experience and expertise, we provide high-quality container vanning services tailored to the needs of every industry.',
  },
  values: {
    title: 'Our Values',
    quality: {
      title: 'Quality Commitment',
      description: 'We maintain the highest standards in all operations and handle your cargo with care.',
    },
    efficiency: {
      title: 'Efficiency',
      description: 'Fast and accurate operations save you time and costs.',
    },
    reliability: {
      title: 'Reliability',
      description: 'We keep our promises and consistently exceed customer expectations.',
    },
    innovation: {
      title: 'Innovation',
      description: 'We adopt the latest technologies and methods to continuously improve our services.',
    },
  },
  team: {
    title: 'Experienced Team',
    description: 'Our team consists of container vanning specialists. Staff with years of experience and expertise handle your cargo safely.',
  },
  contact: {
    title: 'Contact Us',
    address: 'Address',
    phone: 'Phone',
    email: 'Email',
    hours: 'Business Hours',
    hoursValue: 'Monday - Friday: 9:00 - 18:00',
  },
};

// Services Page
export const servicesPage = {
  hero: {
    title: 'Our Services',
    subtitle: 'We provide comprehensive container vanning services tailored to the needs of every industry.',
  },
  list: {
    title: 'Service List',
    containerVanning: {
      title: 'Container Vanning',
      description: 'Safe and efficient container loading by professional staff. We handle cargo of all sizes and types.',
      features: ['20ft, 40ft, 40ft HC containers', 'Professional staff', 'Cargo safety assurance', 'Efficient loading'],
    },
    cargoInspection: {
      title: 'Cargo Inspection',
      description: 'Thorough quality checks before shipment ensure your cargo arrives in perfect condition.',
      features: ['Quality check', 'Quantity verification', 'Damage inspection', 'Detailed reports'],
    },
    warehousing: {
      title: 'Warehousing',
      description: 'We carefully store your cargo in safe and clean warehouse facilities.',
      features: ['24/7 security', 'Temperature control', 'Inventory management system', 'Short & long-term storage'],
    },
    customsClearance: {
      title: 'Customs Support',
      description: 'We provide support to smoothly navigate complex customs procedures.',
      features: ['Document preparation', 'Customs clearance agency', 'Tariff consultation', 'Fast processing'],
    },
    packagingServices: {
      title: 'Packaging Services',
      description: 'Appropriate packaging for each cargo type ensures safety during transport.',
      features: ['Professional materials', 'Custom packaging', 'Protection measures', 'Eco-friendly'],
    },
    logisticsConsulting: {
      title: 'Logistics Consulting',
      description: 'We propose optimal logistics solutions for your business.',
      features: ['Cost optimization', 'Route planning', 'Efficiency support', 'Long-term partnership'],
    },
  },
  booking: {
    title: 'Booking Services',
    description: 'Easy online booking. Choose the service that fits your needs.',
    delivery: {
      title: 'Delivery Booking',
      description: 'Schedule your cargo delivery',
    },
    loading: {
      title: 'Loading Booking',
      description: 'Book container loading operations',
    },
    forwarding: {
      title: 'Forwarding Booking',
      description: 'Book international shipping services',
    },
  },
  cta: {
    title: 'Need a Quote?',
    description: 'We propose the best solution tailored to your needs. Feel free to contact us.',
    button: 'Contact Us',
  },
};

export const profile = {
  my_account: 'My Account',
  hero_title: 'Profile Settings',
  hero_subtitle: 'View and edit your account information',
  tab_profile: 'Profile',
  tab_password: 'Change Password',
  section_basic: 'Basic Information',
  section_password: 'Change Password',
  field_name: 'Full Name',
  field_company: 'Company Name',
  field_phone: 'Phone Number',
  field_email: 'Email Address',
  field_address: 'Company Address',
  email_readonly: 'Email address cannot be changed',
  placeholder_name: 'John Smith',
  placeholder_company: 'Your Company Ltd.',
  placeholder_phone: '+81 90-0000-0000',
  placeholder_address: 'e.g. 1-2-3 Minato-ku, Tokyo',
  avatar_upload: 'Upload Photo',
  avatar_delete: 'Delete Photo',
  avatar_hint: 'Click the avatar to change your photo',
  role_admin: 'Admin',
  role_member: 'Member',
  back: 'Back',
  save: 'Save Changes',
  saving: 'Saving...',
  saved_profile: 'Profile updated successfully',
  error_name_required: 'Please enter your name',
  error_update_failed: 'Update failed. Please try again.',
  field_current_password: 'Current Password',
  field_new_password: 'New Password',
  field_confirm_password: 'Confirm New Password',
  placeholder_current_password: 'Current password',
  placeholder_new_password: 'At least 6 characters',
  placeholder_confirm_password: 'Enter password again',
  password_hint: 'At least 6 characters',
  update_password: 'Update Password',
  updating_password: 'Updating...',
  saved_password: 'Password updated successfully',
  error_wrong_password: 'Current password is incorrect',
  error_password_short: 'New password must be at least 6 characters',
  error_password_mismatch: 'Passwords do not match',
  image_size_error: 'Image size must be 5MB or less',
};

export const transition = {
  login_verifying: 'Verifying...',
  login_complete: 'Login Complete',
  login_welcome: 'Welcome, ',
  login_welcome_suffix: '',
  logout_signing: 'Signing out...',
  logout_complete: 'Logged Out',
  logout_message: 'See you next time',
};
